export const checkValidation = (
  name,
  monthlySalary,
  email,
  number,
  message,
) => {
  const validateEntries = {}
  if (typeof name !== 'undefined') {
    validateEntries.name = isNameValid(name)
  }

  if (typeof monthlySalary !== 'undefined') {
    validateEntries.monthlySalary = isMonthlySalaryValid(monthlySalary)
  }

  if (typeof email !== 'undefined') {
    validateEntries.email = isEmailValid(email)
  }

  if (typeof number !== 'undefined') {
    validateEntries.number = isNumberValid(number)
  }

  if (typeof message !== 'undefined') {
    validateEntries.message = isMessageValid(message)
  }

  return {
    status: Object.values(validateEntries).every((value) => value === true),
    validateEntries,
  }
}
export const formFieldValidation = (params) => {
  const validateEntries = Object.keys(params).reduce(
    (oldReturnable, fieldName) => {
      return {
        ...oldReturnable,
        [fieldName]: getFieldValidation(fieldName, params[fieldName]),
      }
    },
    {},
  )
  const status = Object.values(validateEntries).every((value) => Boolean(value))
  return { validateEntries, status }
}

export const getFieldValidation = (fieldName, value) => {
  switch (fieldName) {
    case 'name':
      return isNameValid(value.trim())
    case 'monthlySalary':
      return isMonthlySalaryValid(value)
    case 'number':
    case 'phone':
      return isNumberValid(value)
    case 'email':
      return isEmailValid(value)
    case 'message':
      return isMessageValid(value)
    default:
      return Boolean(value)
  }
}

export const isNameValid = (value) =>
  new RegExp(
    /^([-'.a-zA-Z\u0600-\u06FF]+(?: [-'.a-zA-Z\u0600-\u06FF']+){0,3})$/,
  ).test(value.trim())

export const isMonthlySalaryValid = (value) =>
  new RegExp(/^(?!0+(?:\.0+)?$)[0-9]+(?:\.[0-9]+)?$/).test(value)

export const isEmailValid = (value) =>
  new RegExp(/^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]/).test(value)

export const isNumberValid = (value) => new RegExp(/^\d{8}$/).test(value)

export const isMessageValid = (value) =>
  new RegExp(/^[-_.,@()&!'?0-9a-zA-Z\u0600-\u06FF\s]+$/).test(value)
